<template>
  <ConfirmModal ref="modal">
    <div
      v-if="warning && canSeeCommissionNotes"
      class="flex flex-col gap-1 text-sm"
    >
      <a
        v-for="note in notes"
        :key="note.id"
        :href="noteHref(note)"
        target="_blank"
        rel="noopener noreferrer"
        class="text-primary hover:underline"
      >
        {{ note.reference }}
      </a>
    </div>
  </ConfirmModal>
</template>

<script>
import ConfirmModal from '@c/addf-package/components/modal/ConfirmModal.vue'
import { commissionWarningText } from '@c/baseComponents/modal/invoicing/commissionWarning'

/**
 * Tells that a change on an invoice (conversion, new responsible) moved, or
 * kept, the commission of the sale. Only opened when the API sends a
 * `commission_warning`, i.e. when the responsible changed.
 */
export default {
  name: 'CommissionWarningModal',
  components: { ConfirmModal },
  data() {
    return { warning: null }
  },
  computed: {
    canSeeCommissionNotes() {
      return [
        'see_own_commission_notes',
        'manage_commission_notes',
        'manage_commission_settings'
      ].some((permission) => this.$can(permission))
    },
    notes() {
      return [
        this.warning?.previous_commission_note,
        this.warning?.commission_note
      ].filter(Boolean)
    }
  },
  methods: {
    /** Resolves when the user closes the alert. */
    show(warning) {
      this.warning = warning
      const { title, message } = commissionWarningText(
        (key, params) => this.$t(key, params),
        warning
      )

      return this.$refs.modal.show({
        title,
        message,
        okButton: this.$t('button.close')
      })
    },
    noteHref(note) {
      return this.$router.resolve({
        name: 'commission_note_show_route',
        params: { id: note.id }
      }).href
    }
  }
}
</script>
